import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import { DESKTOP_MIN_WIDTH, METHOD_PAYTO, TABLET_MAX_WIDTH } from 'constants';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import { isArray, isEmpty, isFunction } from 'lodash';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  paragraph500Mixin,
  paragraph700Mixin,
} from 'styles';

const AuthorisePaytoAccountTimeoutPopup = ({
  isOpen,
  imageSrc,
  imagesStyles,
  text,
  content,
  alignContent = 'left' || 'center' || 'right',
  buttonLabel1,
  buttonLabel2,
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  isClickBackdropToClose = false,
  onSelect,
  handleFXPaymentMethodAutoSelect,
  handleTOPaymentMethodAutoSelect,
  fetchPaytoAccountsAgreementLatest,
  onPaytoAccountAuthoriseCheckStatus,
  modalOptions,
}) => {
  const { t } = useLang();

  const { isEdit } = modalOptions || {};

  const {
    resetPaytoMaxAmountEdited,
    resetPaytoAccountAuthorising,
    resetPaytoAgreementEditing,
    setPaytoAccountsAgreement,
    isAccountAgreementEditing,
    paytoAccountAuthorising,
  } = usePaytoStore();

  const isShowCloseButton = buttonLabel1 && isFunction(onClose);

  const [isAllowRefreshStatus, setAllowRefreshStatus] = useState(true);

  const handleOnClickBackdropToClose = () => {
    if (isClickBackdropToClose) {
      onClose();
    }
  };

  const handleOnClick = () => {
    console.log(`⭐ AuthorisePaytoAccountTimeoutPopup 👉 handleOnClick ↩`);
    setPaytoAccountsAgreement();
    onClick();
    if (isAccountAgreementEditing) {
      fetchPaytoAccountsAgreementLatest((accountsAgreement) => {
        let accountAgreement = null;
        if (!isEmpty(accountsAgreement) && isArray(accountsAgreement)) {
          accountAgreement =
            accountsAgreement?.find(
              (item) =>
                item?.paymentAgreementUID ===
                paytoAccountAuthorising?.paymentAgreementUID
            ) || null;
        }
        handleFXPaymentMethodAutoSelect(METHOD_PAYTO, accountAgreement);
        handleTOPaymentMethodAutoSelect(METHOD_PAYTO, accountAgreement);
        resetPaytoMaxAmountEdited();
        resetPaytoAccountAuthorising();
        resetPaytoAgreementEditing();
      });
    } else {
      fetchPaytoAccountsAgreementLatest(() => {
        handleFXPaymentMethodAutoSelect(METHOD_PAYTO);
        handleTOPaymentMethodAutoSelect(METHOD_PAYTO);
        resetPaytoMaxAmountEdited();
        resetPaytoAccountAuthorising();
        resetPaytoAgreementEditing();
      });
    }
  };

  const handleOnClickRefreshStatus = () => {
    onPaytoAccountAuthoriseCheckStatus(() => {
      setAllowRefreshStatus(false);
    }, isEdit);
  };
  const renderRefreshStatusAgreementAuthoriseTimeoutButton = () => {
    if (!isAllowRefreshStatus) return null;
    return (
      <>
        <SizeBox height={4} />
        <RefreshStatusAgreementAuthoriseTimeoutButton
          onClick={handleOnClickRefreshStatus}
        >
          {t('button_authorise_payto_account_timeout_cta')}
        </RefreshStatusAgreementAuthoriseTimeoutButton>
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              z-index: ${zIndexModal || 1101};
            }
          }
        `
          : ``}

        {isBackdropOverlap
          ? `
          .alert-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .alert-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={handleOnClickBackdropToClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="alert-modal-backdrop"
        centered
      >
        <ModalBody>
          {imageSrc && (
            <>
              <ImageWrap>
                <img
                  src={imageSrc}
                  alt=""
                  width={50}
                  height={50}
                  style={imagesStyles}
                />
              </ImageWrap>
              <SizeBox height={10} />
            </>
          )}
          {text && <Text dangerouslySetInnerHTML={{ __html: text }} />}
          {renderRefreshStatusAgreementAuthoriseTimeoutButton()}
          <SizeBox height={20} />
          {content && (
            <SubText
              $alignContent={alignContent}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </ModalBody>
        <ModalFooter
          style={{
            justifyContent: !buttonLabel1 && 'center',
          }}
        >
          {isShowCloseButton && (
            <ButtonCommon
              value={buttonLabel1}
              onClick={onClose}
              styles={{
                margin: '0px',
                width: '50%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
            />
          )}
          <ButtonCommon
            value={buttonLabel2}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              width: isShowCloseButton ? '50%' : '100%',
            }}
            onClick={handleOnClick}
            isUseKeyDown
          />
        </ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 14px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 328px;
      height: fit-content;
      margin-inline: auto;
      border: none;

      @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
        width: 436px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 24px;
  text-align: left;
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Text = styled.p`
  ${paragraph700Mixin};
  text-align: center;
`;
const SubText = styled.p`
  ${paragraph500Mixin};
  text-align: ${(props) => props.$alignContent};
  white-space: break-spaces;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

const RefreshStatusAgreementAuthoriseTimeoutButton = styled.div`
  ${cursorPointerMixin};
  ${paragraph500Mixin};
  color: var(--ds-c-blue-hyperlink-default);
  text-decoration: underline;
`;

export default AuthorisePaytoAccountTimeoutPopup;
